import { withPixleeUploaderProps } from 'viewModel/gallery/withPixleeUploaderProps';
import PixleeUploader from 'components/Community/PixleeUploader/PixleeUploader';

export default withPixleeUploaderProps(PixleeUploader);
